import { useEffect, useRef, useState } from "react";

const ReviewsSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loaded) {
          setLoaded(true);
          const script = document.createElement("script");
          script.src = "https://reputationhub.site/reputation/assets/review-widget.js";
          script.type = "text/javascript";
          script.async = true;
          document.body.appendChild(script);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [loaded]);

  return (
    <section ref={sectionRef} className="section-padding bg-background">
      <div className="container-custom">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-secondary mb-4">
            WHAT OUR <span className="text-primary">CUSTOMERS SAY</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            5-Star Rated Service Across MD, WV & VA
          </p>
        </div>

        {/* External Reviews Widget */}
        <div className="w-full" style={{ minHeight: "400px" }}>
          <iframe 
            className="lc_reviews_widget" 
            src="https://reputationhub.site/reputation/widgets/review_widget/6MWqSixNchvWXQgoKgWl?widgetId=6984e9034f5df24696b57fd2" 
            style={{ minWidth: "100%", width: "100%", border: "none", minHeight: "400px" }}
            title="Customer Reviews"
            loading="lazy"
          />
        </div>

        {/* Leave a Review CTA */}
        <div className="mt-16 max-w-2xl mx-auto animate-fade-in">
          <div className="border-2 border-primary bg-gradient-to-br from-primary/10 to-primary/5 shadow-xl rounded-lg p-8 md:p-10 text-center">
            <div className="flex justify-center mb-6">
              <div className="bg-white p-4 rounded-full shadow-lg">
                <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                </svg>
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold font-heading text-secondary mb-3">LEAVE US A REVIEW</h3>
            <p className="text-lg text-muted-foreground mb-6">Share your experience and help others discover quality power washing services</p>
            <a href="/review" className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-lg">
              Write a Google Review
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;